import { render, staticRenderFns } from "./AwardList.vue?vue&type=template&id=07d0282c&scoped=true"
import script from "./AwardList.vue?vue&type=script&lang=js"
export * from "./AwardList.vue?vue&type=script&lang=js"
import style0 from "./AwardList.vue?vue&type=style&index=0&id=07d0282c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0282c",
  null
  
)

export default component.exports